var map = {
	"./da.json": 5638,
	"./de.json": 9929,
	"./el.json": 7498,
	"./en.json": 790,
	"./es.json": 8563,
	"./fr.json": 844,
	"./hu.json": 4626,
	"./it.json": 504,
	"./ja.json": 8566,
	"./pl.json": 5143,
	"./pt.json": 9898,
	"./ru.json": 9672,
	"./sv.json": 3244,
	"./tr.json": 2021,
	"./zh.json": 6538
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1845;